import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { ModalShell } from '../../shared/ModalShell';

interface UnfilledBlanksConfirmModalProps {
    blanks: string[];
    onSend: () => void;
    onCancel: () => void;
}

export function UnfilledBlanksConfirmModal({
    blanks,
    onSend,
    onCancel
}: UnfilledBlanksConfirmModalProps) {
    return (
        <ModalShell
            widthClassName="max-w-md"
            dismissible
            onDismiss={onCancel}
            labelledBy="unfilled-blanks-title"
        >
            <div className="flex items-start gap-4">
                <span className="flex-shrink-0 w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
                    <ExclamationTriangleIcon className="w-5 h-5 text-amber-600" />
                </span>
                <div className="flex-1 min-w-0">
                    <h3 id="unfilled-blanks-title" className="text-lg font-semibold text-gray-900">
                        Unfilled blanks
                    </h3>
                    <p className="text-sm text-gray-600 mt-1 break-words">
                        This message still has blanks to fill: {blanks.join(', ')}. Send anyway?
                    </p>
                </div>
            </div>
            <div className="flex justify-end items-center gap-3 mt-6">
                <button
                    type="button"
                    autoFocus
                    onClick={onCancel}
                    className="bg-white text-gray-800 border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors font-semibold text-sm"
                >
                    Keep editing
                </button>
                <button
                    type="button"
                    onClick={onSend}
                    className="bg-gray-800 text-white rounded-lg px-4 py-2 text-sm font-semibold hover:bg-gray-900 transition-colors"
                >
                    Send anyway
                </button>
            </div>
        </ModalShell>
    );
}
